module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-7-cdf52243d4486bb19fea9ae5d857f71c.jpg";